module.exports = __webpack_public_path__ + "static/media/DSC_6835.93942a07.jpg";